import chroma from 'chroma-js';

export const resolveTextColor = (textColor: 'auto' | 'light' | 'dark', primaryColor: string): string => {
  if (textColor === 'light') return '#ffffff';
  if (textColor === 'dark') return '#1c2024';
  try {
    return chroma(primaryColor).luminance() > 0.179 ? '#1c2024' : '#ffffff';
  } catch {
    return '#ffffff';
  }
};

export const loadImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });

export const isValidHex = (hex: string) => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);

export const optimizeImage = async (file: File, maxSize = 400, quality = 0.8): Promise<string> => {
  const url = URL.createObjectURL(file);
  try {
    const img = await loadImage(url);

    const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
    const width = Math.round(img.width * scale);
    const height = Math.round(img.height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Could not create canvas context');

    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL('image/webp', quality);
  } finally {
    URL.revokeObjectURL(url);
  }
};
